import { StepPageWrapper } from '@Layout/StepPageWrapper';
import { FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { AccountantPersonalDetailsForm } from './AccountantPersonalDetailsForm';
import { useAccountantPersonalDetailsLogic } from './hooks/useAccountantPersonalDetailsLogic';

export const AccountantPersonalDetails = () => {
  const { t } = useTranslation('inviteTeamMember');
  const { formMethods, handleSubmit, isLoading } = useAccountantPersonalDetailsLogic();

  return (
    <FormProvider {...formMethods}>
      <StepPageWrapper
        handleSubmit={handleSubmit}
        heading={t('accountantPersonalDetails.title')}
        formMethods={formMethods}
        customSubmitTitle={t('accountantPersonalDetails.acceptAndContinue')}
        footerInputSlot={<></>}
        isLoading={isLoading}
        shouldStrechCta>
        <AccountantPersonalDetailsForm />
      </StepPageWrapper>
    </FormProvider>
  );
};

export default AccountantPersonalDetails;
